import React from "react";

import Button from "@common/components/Button/Button";
import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Spinner } from "@common/components/Spinner/Spinner";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import useReleaseHealthScoring from "@main/pages/Release/consumers/useReleaseHealthScoring";
import { MetricScoreOutletContext } from "@main/pages/Release/views/MetricDetails/ReleaseMetricDetailsLayout";
import { MetricRow } from "@main/pages/Release/views/MetricDetails/shared/MetricRow";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";
import { useOutletContext } from "react-router-dom";

import * as Styled from "./ReleaseHealthScoreView.styles";

export default function ReleaseHealthScoreView() {
  const { refetchReleaseStatus } = useOutletContext<MetricScoreOutletContext>();
  const { thresholdRows, percentageSum, isError, scoringConfigLoading, handleSave, isSaving } =
    useReleaseHealthScoring(refetchReleaseStatus);

  if (scoringConfigLoading) {
    return <Spinner />;
  }

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          Score
        </Heading>
        <Paragraph>{"Adjust how much each metric contributes to the overall ‘Release health’ score."}</Paragraph>

        <Styled.ThresholdList>
          {thresholdRows.map((row) => (
            <Flex
              key={row.label}
              $column
            >
              <Heading
                heading4
                fontWeight={"bold"}
                marginBottom={16}
              >
                {row.label}
              </Heading>
              <MetricRow
                key={row.score}
                description={row.description}
                value={row.value}
                error={row.error}
                onChange={row.onChange}
                score={row.score}
                unit={"%"}
                showScore
              />
            </Flex>
          ))}
        </Styled.ThresholdList>

        <Flex
          $alignItems="center"
          $gap={2}
        >
          <Button
            type="submit"
            size="small"
            disabled={isError || isSaving}
            onClick={handleSave}
          >
            {isSaving ? "Saving..." : "Save"}
          </Button>
          {isError && (
            <Paragraph
              style={{ color: vars.colors.red }}
              p2
            >{`Total: ${percentageSum}% (must equal 100%)`}</Paragraph>
          )}
        </Flex>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
